
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M229 44.6C155.3 55.3 93.9 107.9 72.4 178.8c-6 19.9-7.7 31.9-7.8 54.7 0 21.3.9 28.8 5.9 47.3 14.8 55.2 59.8 113.3 126.6 163.7 33.8 25.5 42.1 29.2 62.4 28.3 7.5-.4 11.7-1.2 16.8-3.1 8.1-3.1 26-15.1 45.7-30.6 89.3-70.2 132.4-146.6 125.1-221.6-4.4-45.1-22.1-83.8-53.1-115.9-30.5-31.6-68.5-51-111.9-57-13.7-1.9-39.8-1.9-53.1 0m40.1 41.5c27.3 2.7 48.3 10.2 70.1 24.8 32 21.5 53.4 52.8 62.5 91.1 3.4 14.7 4.3 38.5 1.8 53.1-9 54.1-54.4 113.1-126.5 164.4-14.2 10.1-18 11.9-22.9 11.1-8.9-1.4-51.6-34.4-76.6-59.2-39.2-38.7-62.7-78.4-69-116.3-2.5-14.6-1.6-38.4 1.8-53.1 15.1-63.6 66.6-109.2 131.2-115.9 11.6-1.2 16.1-1.2 27.6 0"}}),_c('path',{attrs:{"d":"M245.1 150c-12.8 1.8-29.8 8.5-39.1 15.4-6.8 5.1-16.4 15.2-21 22.3-10.4 15.7-14.5 31.1-13.7 50.7.6 14.7 2.2 21 8.6 34.1 10.8 21.8 28.8 36.9 52.6 44.1 8 2.4 10.6 2.7 23.5 2.7s15.5-.3 23.5-2.7c23.1-7 41.3-21.9 51.9-42.6 6.3-12.2 8.7-21.1 9.3-35.6 1.2-26-7.5-47.5-26.4-65.5-11.5-11-24.2-17.8-39.4-21.3-8.5-2-21.9-2.7-29.8-1.6m21.2 43.5c8.4 2.2 13.4 5.1 19.7 11.4 16.4 16.4 16.8 41.8.9 58.6-8.8 9.3-18.5 13.5-31.1 13.5-12.2 0-22.4-4.6-31.1-13.9-14.8-15.9-15-40.5-.3-56.8 10.7-11.8 26.9-16.7 41.9-12.8"}})])
          )
        }
      }
    